module.exports = __webpack_public_path__ + "static/media/tds.a1c61f6a.png";